import { route } from "ziggy-js"
import type { AccountDomain } from "@shared/models/AccountDomain/AccountDomain"

export const shopRoute = (routeName: string, params: unknown[], domain: AccountDomain | null = null) => {
  const sdUrlString = route(routeName, params)

  if (!domain) {
    return sdUrlString
  }

  // Generate URL for custom domain
  const sdUrl = new URL(sdUrlString)
  const newHost = domain.incoming_address
  // Strip leading `/s/{account}`
  const newPath = sdUrl.pathname.replace(/^\/s\/\d+/, "")

  let out = `https://${newHost}${newPath}`
  if (sdUrl.searchParams.size > 0) {
    out += `?${sdUrl.searchParams.toString()}`
  }

  return out
}
